// File: src/components/layout/Header.jsx
// Updated with mobile menu button

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { LogOut, User, Menu } from 'lucide-react';
import logo from '../../assets/logo14.png';
import '../../styles/unified.css';
import ActingAsSelector from '../common/ActingAsSelector';

const Header = ({ onMobileMenuToggle }) => {
  const { user, logout } = useAuth0();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout({ 
      logoutParams: { 
        returnTo: window.location.origin 
      }
    });
  };

  return (
    <header className="app-header-new">
      <div className="header-container">
        {/* Mobile Menu Button - Shows only on mobile */}
        <button 
          className="mobile-menu-toggle" 
          onClick={onMobileMenuToggle}
          aria-label="Toggle menu"
        >
          <Menu size={24} />
        </button>

        {/* Logo Section */}
        <div className="header-logo">
          <img src={logo} alt="Logo" className="logo-image" />
          <span className="logo-text">Booking System</span>
        </div>

        {/* User Profile & Actions */}
        <div className="header-actions">

          <ActingAsSelector />
          
          <div
            className="user-info"
            onClick={() => navigate('/my-account')}
            title="View my account"
            style={{ cursor: 'pointer' }}
          >
            {user?.picture ? (
              <img src={user.picture} alt={user.name} className="user-avatar" />
            ) : (
              <div className="user-avatar-placeholder">
                <User size={20} />
              </div>
            )}
            <span className="user-name">{user?.name}</span>
          </div>
          
          <button onClick={handleLogout} className="btn-logout-header">
            <LogOut size={18} />
            <span className="logout-text">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;